<template lang="">
    <div class="con">
        <img src="../../assets/img/LoginSuccessLogo.png" alt="">
        <p>微信认证成功</p>
    </div>
</template>
<script>
import { doLogin, wxLogin } from "@/api/map/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      dataParms: {
        code: ''
      },
      openid: null,  //微信授权登录后返回的openID
    }
  },
  // 因为是在当前页面添加code的，界面没有刷新，只是添加参数，所以就必须监测路由参数的变化
  watch: {
    $route() {
      if (this.$route.query.code != undefined) {
        this.getWeixin(this.$route.query.code, this.$route.query.state);
      }
    }
  },
  // js代码
  created() {
    // 禁用浏览器返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
    this.dataParms.code = this.getUrlKey("code");
    // console.log('code', this.dataParms.code)
    // if (this.dataParms.code) {
    this.getWeixin();
    // }
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面
    window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  methods: {
    //  公共方法
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [",", ""])[1].replace(/\+/g, '%20')) || null;
    },
    // 通过code获取微信信息
    getWeixin() {
      //调用接口，将code传给后端
      let obj = {
        code: this.dataParms.code
      }
      wxLogin(obj).then((res) => {
        // console.log('登录结果', res)
        if (res.data.code == 200) {
          this.openid = res.data.data.openid;
          // console.log('openid', this.openid)
          if (res.data.data.loginInfo) {
            let userInfo = res.data.data.loginInfo
            this.$store.commit('SET_NAME', userInfo.name);
            this.$store.commit('SET_USERID', userInfo.userId);
            this.$store.commit('SET_SEX', userInfo.sex);
            this.$store.commit('SET_IDCARD', userInfo.idCard);
            this.$store.commit('SET_PHONE', userInfo.phone);
            this.$store.commit('SET_TOKEN', res.data.data.token);
            this.$store.commit('SET_REVERSEURL', userInfo.reverseUrl);
            this.$store.commit('SET_FRONTURL', userInfo.frontUrl);
            localStorage.setItem('token', res.data.data.token)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            // console.log('vuex:', this.$store.state, this.$store.state.name)
            // this.$router.go(-2);
            let fromPath = localStorage.getItem('fromPath')
            // this.$router.resolve({path:'/'+fromPath})
            // window.open(routeUrl.href, "_blank");
            const {href} = this.$router.resolve({path: fromPath})
            // console.log(href,'链接？？')
            window.open(href, '_blank')
            // this.$router.push({ name: fromPath, replace: true })
            // if (fromPath == 'Disclosure') {
            //   this.$router.push({ name: 'Disclosure' })
            // } else if (fromPath == 'ServiceGuide') {
            //   this.$router.push({ name: 'ServiceGuide' })
            // }
          } else {
            this.$router.push({
              name: 'BasicInformationBinding',
              params: { openid: this.openid }
            })
          }
        } else {
          this.$message.error('微信登录失败，请稍后重试！')
        }
      })
    },
    // 禁用浏览器返回
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
  },
  beforeRouteEnter(to,from,next){
    if(from.fullPath=='/WeiXinLogin'){
      next();
    }else{
      next({ path: '/' })
    }
  }
}
</script>
<style scoped>
.con {
  margin-top: 50px;
  margin-bottom: 50px;
}

.con p {
  margin: 10px 0;
}
</style>
